import { FC, useContext } from 'react'
import { Grid } from '@mui/material'

import { DIALOG_FORM_FOOTER } from '@constants'

import { FormContext } from '../../DisplayForm'
import { ContainerOnForm } from '../ContainerOnForm'

type ConfiguredFormElementsProps = {
  availableFormHeight: number
}

export const ConfiguredFormElements: FC<ConfiguredFormElementsProps> = ({
  availableFormHeight,
}) => {
  const { containers } = useContext(FormContext)

  return (
    <Grid container>
      <Grid item xs zeroMinWidth height={`calc(100% - ${DIALOG_FORM_FOOTER}px)`}>
        {containers.map((container, containerIndex) => (
          <ContainerOnForm
            key={container.id}
            availableFormHeight={availableFormHeight}
            container={container}
            index={containerIndex}
          />
        ))}
      </Grid>
    </Grid>
  )
}
